// extracted by mini-css-extract-plugin
module.exports = {"primaryColumn":"primaryColumn_uoo95","primaryColumnIcon":"primaryColumnIcon_Cdn7b","rightAlignedColumn":"rightAlignedColumn_3l3Cn","nonwrappingColumn":"nonwrappingColumn_vh1WF"};